import { render } from "./GhostPvpModal.vue?vue&type=template&id=6e7c2a80&scoped=true"
import script from "./GhostPvpModal.vue?vue&type=script&lang=js"
export * from "./GhostPvpModal.vue?vue&type=script&lang=js"

import "./GhostPvpModal.vue?vue&type=style&index=0&id=6e7c2a80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e7c2a80"]])

export default __exports__